import { HTMLAttributes } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { useStyles } from './consultation-modal.styles';
import { Modal, ResponsiveWidth } from '../../../../common';
import { ConsultationModalProps } from './consultation-modal.models';
import { Button } from '../../../../common/button-new';
import { formatPhoneNumberDisplay } from '../../../../../utils';

export const ConsultationModal = ({ phone, onClose, ...props }: ConsultationModalProps): JSX.Element => {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <Modal
      {...props}
      onClose={onClose}
      data-testid="ecp-cataract-modal"
      responsiveWidth={ResponsiveWidth.mdWide}
      propsPaperStyles={classes.paper}
      PaperProps={{ 'data-testid': 'ecp-cataract-modal-content' } as HTMLAttributes<HTMLDivElement>}
      title={intl.formatMessage({ id: 'ecp.cataract.title' })}
      titleStyles={classes.title}
      content={(
        <>
          <p
            className={classes.description}
            data-testid="ecp-cataract-modal-text"
          >
            <FormattedMessage id="ecp.cataract.text" />
          </p>
          <Button
            style="darker"
            to={`tel:${phone}`}
            testId="ecp-cataract-modal-button"
            rootClasses={classes.button}
          >
            <FormattedMessage id="ecp.cataract.call" />
            {formatPhoneNumberDisplay(phone)}
          </Button>
        </>
      )}
    />
  );
};
